// Capture once before the global Auth client consumes/cleans its callback URL.
// A pre-existing browser session is never evidence of a password recovery.
export function capturePasswordRecoveryProof(location) {
  const fragment = new URLSearchParams(String(location?.hash || '').replace(/^#/, ''))
  const search = new URLSearchParams(String(location?.search || ''))
  if (['error', 'error_code', 'error_description'].some(key => fragment.has(key) || search.has(key))) return Object.freeze({kind:'error'})
  if (fragment.get('type') === 'invite') return Object.freeze({kind:'invite'})
  const token = fragment.get('access_token')
  if (fragment.get('type') !== 'recovery' || !token || /\s/.test(token)) return Object.freeze({kind:'absent'})
  return Object.freeze({kind:'recovery',accessToken:token})
}
